import React, { useEffect, useState } from "react";
import ApiTokenService from "../../services/v2/management/apitoken-service";
import { FaTimes } from "react-icons/fa";

const ApiTokenAdd = ({ isOpen, onClose, onSuccess }) => {
  const [description, setDescription] = useState("");
  const [ttlInHours, setTtlInHours] = useState("1");
  const [creating, setCreating] = useState(false);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setDescription("");
      setTtlInHours("1");
      setResponse(null);
      setCreating(false);
    }
  }, [isOpen]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setCreating(true);
    setResponse(null);

    const payload = {
      roles: ["CDR.Read"], // Fijo
      ttlInHours,
      description,
    };

    try {
      const response = await ApiTokenService.create(payload); // Llamada al servicio
      if (response.data.status === "Success") {
        setResponse({
          type: "success",
          message: "Token successfully created!",
          token: response.data.token,
        });
        onSuccess(); // Actualiza la lista de tokens
      }
    } catch (err) {
      console.error("Error creating token:", err);
      setResponse({
        type: "error",
        message:
          err?.response?.data?.error ||
          "Failed to create token. Please try again.",
      });
    } finally {
      setCreating(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-1/3 max-w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
            Add API Token
          </h2>
          <button
            onClick={onClose}
            className="text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          >
            <FaTimes />
          </button>
        </div>

        {response && response.type === "success" ? (
          <div className="text-center">
            <div className="mb-4">
              <span className="inline-block px-4 py-2 bg-green-500 text-white rounded-lg text-sm">
                {response.message}
              </span>
            </div>
            <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-md mb-4">
              <p className="text-sm text-gray-700 dark:text-gray-300">
                Make sure to copy the token below, as you won’t be able to view
                it again later.
              </p>
              <span className="inline-block px-4 py-2 bg-gray-300 text-gray-800 dark:bg-gray-600 dark:text-gray-100 rounded-lg text-sm mt-2">
                {response.token}
              </span>
            </div>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
            >
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            {response && response.type === "error" && (
              <div className="mb-4">
                <span className="inline-block px-4 py-2 bg-red-500 text-white rounded-lg text-sm">
                  {response.message}
                </span>
              </div>
            )}
            <div>
              <label
                htmlFor="description"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Description
              </label>
              <input
                id="description"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            <div>
              <label
                htmlFor="ttlInHours"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Time to Live (TTL)
              </label>
              <select
                id="ttlInHours"
                value={ttlInHours}
                onChange={(e) => setTtlInHours(e.target.value)}
                className="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="1">1 hour</option>
                <option value="24">1 day</option>
                <option value="168">1 week</option>
                <option value="720">1 month</option>
                <option value="2160">3 months</option>
                <option value="4320">6 months</option>
                <option value="8760">1 year</option>
                <option value="87600">10 years</option>
              </select>
            </div>

            <div>
              <label
                htmlFor="roles"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300"
              >
                Roles
              </label>
              <select
                id="roles"
                value="CDR.Read"
                disabled
                className="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 cursor-not-allowed"
              >
                <option value="CDR.Read">CDR.Read</option>
              </select>
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                disabled={creating}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                {creating ? "Creating..." : "Create Token"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ApiTokenAdd;
